import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Map from './pages/MapData';
import DataInput from './pages/DataInput';
import Admin from './pages/Admin';
import Record from './pages/Record';
import Records from './pages/Records';
import Reporting from './pages/Reporting';
import '@aws-amplify/ui-react/styles.css';
import { Amplify } from 'aws-amplify';
import { withAuthenticator } from '@aws-amplify/ui-react';
import { useTheme, View } from '@aws-amplify/ui-react';
import Logo from './components/Logo';
import awsConfig from '../aws-exports';

Amplify.configure(awsConfig);

interface ComponentsType {
  Header: () => JSX.Element;
}

const components: ComponentsType = {
  Header() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large} backgroundColor={'#fff'}>
        <Logo />
      </View>
    );
  }
};

interface AppProps {
  hideSignUp?: boolean;
}

const App: React.FC<AppProps> = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/map" element={<Map />} />
        <Route path="/datainput" element={<DataInput />} />
        <Route path="/reporting" element={<Reporting />} />       
        <Route path="/admin" element={<Admin />} />
        <Route path="/records" element={<Records />} />
        <Route path="/record/:id" element={<Record />} />
      </Routes>
    </Router>
  );
};

export default withAuthenticator(App, {
  hideSignUp: true,
  components
}); 